/* eslint-disable no-nested-ternary */
/* eslint-disable new-cap */
import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  Table,
} from 'antd';
import H3FormInput from '@Uilib/h3FormInput';
import MOActions from '@Actions/moActions';
import H3Text from '@Uilib/h3Text';
import './style.scss';
import HideValue from '../../../../../../Common/RestrictedAccess/HideValue';

/**
 *
 */
class OtherCharges extends Component {
  /**
   *
   * @param props
   */
  constructor(props) {
    super(props);
    const { priceMasking } = props;
    const { isDataMaskingPolicyEnable, isHideCostPrice, isHideSellingPrice } = priceMasking;
    this.state = {
      otherChargeColumns: [
        {
          title: 'Charge Name',
          render: (item) => `${item?.charge_name} `,
        },
        {
          title: 'Estimated Cost',
          render: (item) => ((isDataMaskingPolicyEnable && isHideCostPrice) ? <HideValue showPopOver popOverMessage={"You don't have access to view estimated cost"} /> : this.props.MONEY(item?.est_charge_amount || '0')),
        },
        {
          title: 'Incurred Cost',
          render: (item) => ((isDataMaskingPolicyEnable && isHideCostPrice) ? <HideValue showPopOver popOverMessage={"You don't have access to view incurred cost"} /> : this.props.MONEY(item?.charge_amount || '0')),
        },
        {
          title: 'Actual Cost',
          width: '180px',
          render: (item) => {
            const { extraCharges, updateExtraCharges, disablePriceChange
            } = this.props;
            return (
              <Fragment>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <div style={{ marginRight: '4px' }}>
                    {this.props.MONEY(0).split(0)?.[0]}
                  </div>
                  <H3FormInput
                    value={item.charge_value}
                    type="number"
                    labelClassName="orgFormLabel"
                    inputClassName="orgFormInput"
                    disabled={!this.props.user?.tenant_info?.production_config?.sub_modules?.manufacturing_order?.settings?.allow_flexible_consumption_in_mo || disablePriceChange}
                    onChange={(e) => {
                      const copyData = JSON.parse(JSON.stringify(extraCharges));
                      copyData.map((data) => {
                        if (item.key === data.key) {
                        // eslint-disable-next-line no-param-reassign
                          data.charge_value = e.target.value;
                        }
                        return data;
                      });
                      updateExtraCharges(copyData);
                    }}
                    hideInput={isDataMaskingPolicyEnable && isHideCostPrice}
                    popOverMessage={"You don't have access to view actual cost"}
                  />
                </div>
                {item.charge_value < 0 && <H3Text text="*Please enter a valid amount" className="input-error" />}
              </Fragment>
            );
          },
        },
      ],
    };
  }

  /**
   *
   * @return {JSX.Element}
   */
  render() {
    const {
      updateMOOtherChargesLoading, getMOByIdLoading, extraCharges,
    } = this.props;
    const {
      otherChargeColumns,
    } = this.state;

    return (
      <div className="ant-row">
        <div className="ant-col-md-16">
          <div className="rm-table-wrapper">
            <Table
              showHeader
              size="small"
              title={() => `Other Charges (${extraCharges?.length})`}
              loading={getMOByIdLoading || updateMOOtherChargesLoading}
              columns={otherChargeColumns}
              dataSource={extraCharges || []}
              pagination={false}
              scroll={{ x: true }}
            />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({
  UserReducers, MOReducers,
}) => ({
  user: UserReducers.user,
  MONEY: UserReducers.MONEY,
  updateMOOtherChargesLoading: MOReducers.updateMOOtherChargesLoading,
  selectedMO: MOReducers.selectedMO,
  getMOByIdLoading: MOReducers.getMOByIdLoading,
  priceMasking: UserReducers.priceMasking,
});

const mapDispatchToProps = (dispatch) => ({
  updateMOOtherCharges: (payload, callback) => dispatch(MOActions.updateMOOtherCharges(payload, callback)),
});

OtherCharges.propTypes = {
  getMOByIdLoading: PropTypes.bool,
  selectedMO: PropTypes.any,
  updateMOOtherCharges: PropTypes.func,
  updateMOOtherChargesLoading: PropTypes.bool,
  callback: PropTypes.any,
  updateExtraCharges: PropTypes.func,
  user: PropTypes.any,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(OtherCharges));
